export default "__VITE_ASSET__B2KHkRR9__"